import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";

import { $gitDiff } from "../../internal/git";

/**
 * Hook to get git diff for working directory
 * @param documentId - The document ID
 * @returns The git diff or undefined if not available
 */
export const useGitDiff = (documentId: string | undefined) => {
	const diffAtom = $gitDiff(documentId);
	const diffLoadable = useAtomValue(loadable(diffAtom));
	const refresh = useSetAtom(diffAtom);

	return {
		data: diffLoadable.state === "hasData" ? diffLoadable.data : undefined,
		refresh,
		isLoading: diffLoadable.state === "loading",
		isError: diffLoadable.state === "hasError",
	};
};
